import React from "react";
import { createPortal } from "react-dom";

import { NotificationList } from "./NotificationList";
import { NotificationWrapper } from "./styles";
import { NotificationPortalProps } from "./types";

export const NotificationPortal: React.FC<NotificationPortalProps> = ({
  notifications,
  modalElement,
}) => {
  if (!modalElement) {
    return null;
  }
  return createPortal(
    <NotificationWrapper>
      <NotificationList notifications={notifications} />
    </NotificationWrapper>,
    modalElement,
  );
};
